import { useRef, useState } from "react";
import { http, fmtErr } from "@/lib/api";
import { toast } from "sonner";
import { Upload } from "lucide-react";

export default function ImageUpload({ onUploaded, testid, label = "Upload image" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await http.post("/admin/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded(r.data.url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy}
        className="btn-outline inline-flex items-center gap-2" data-testid={testid}>
        <Upload size={15} /> {busy ? "Uploading…" : label}
      </button>
    </>
  );
}
